import endpointMaker from "configuration/endpoints";
import request from "http/request";
import { ILineitemStatusServer } from "model/lineitems";
import { Integer } from "model/modelTypes";
import store from "redux/store";

export type ICampaignStatisticsServer = {
  id: string;
  spent: number;
  bid: Integer;
  clicks: Integer;
  impression: Integer;
  budget: number;

  lineitems: Array<ILineitemStatusServer>;

  commission: number;
  dailyInstalls: number;
  modelBid: number;
  runState: "STOPPED" | "RUNNING";
};

const fetchStatistics = (
  getEndpoint,
  signal?: AbortSignal,
  ...endpointArgs
) => {
  const state = store.getState();
  return request.getJson(
    getEndpoint(
      state?.auth?.organizationId,
      state?.auth?.accountId,
      ...endpointArgs
    ),
    false,
    signal
  );
};

export function fetchCampaignsListStatistics(
  signal?: AbortSignal
): Promise<ICampaignStatisticsServer[]> {
  return fetchStatistics(endpointMaker.stats.campaignListStats, signal);
}
export const fetchCampaignStatistics = (
  campaignId: string,
  signal?: AbortSignal
) => fetchStatistics(endpointMaker.stats.campaignStats, signal, campaignId);
export const fetchLineitemStatistics = (
  campaignId: string,
  lineitemsIds: string[],
  signal?: AbortSignal
) =>
  fetchStatistics(
    endpointMaker.stats.lineItemStats,
    signal,
    campaignId,
    lineitemsIds
  );
